/**
 * FEAT-106 / S-425 — what a suspended tenant's members see instead of the app.
 * The only way out is the operator reinstating the tenant, so the one action
 * here is signing out.
 */
import { useClerk } from "@clerk/clerk-react";
import { suspendedNoticeText } from "@/lib/tenant-status";

export function SuspendedNotice({ purgeAfter }: { purgeAfter: string | null | undefined }) {
  const clerk = useClerk();
  return (
    <div className="boot-screen" style={{ flexDirection: "column", gap: 12, maxWidth: 520, margin: "0 auto", textAlign: "center" }}>
      <span className="brand-mark">◈</span>
      <strong>Account suspended</strong>
      <span style={{ color: "var(--muted-fg)", fontSize: 14, lineHeight: 1.5 }}>{suspendedNoticeText(purgeAfter)}</span>
      <button type="button" className="btn-ghost" onClick={() => void clerk.signOut()}>
        Sign out
      </button>
    </div>
  );
}
